import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMoanaPaye } from '../../contexts/MoanaPayeContext';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_moana-paye-module/artifacts/oaca6hlg_LOGO%20GROUPE%20AERH%20POLYNESIE%20COULEUR%20%28%C3%A0%20utiliser%20sur%20fond%20clair%29%20PNG%20%282%29.png";

export default function MoanaPayeLogin() {
  const { login, user } = useMoanaPaye();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (user) {
    const dest = user.profil === 'salarie' ? '/moana-paye/mon-espace' : '/moana-paye/dashboard';
    navigate(dest, { replace: true });
    return null;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await login(email, password);
      const dest = data.user?.profil === 'salarie' ? '/moana-paye/mon-espace' : '/moana-paye/dashboard';
      navigate(dest);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0f1520] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-white mb-4 p-2">
            <img src={LOGO_URL} alt="Groupe AERH Polynésie" className="w-full h-full object-contain" />
          </div>
          <h1 className="text-2xl font-bold text-white">Moana Paye</h1>
          <p className="text-slate-500 text-sm mt-1">Gestion de la paie — Polynésie Française</p>
        </div>
        <form onSubmit={handleSubmit} className="bg-[#1a2332] rounded-xl p-6 border border-white/10">
          {error && <div className="bg-red-500/10 border border-red-500/30 text-red-400 text-sm px-3 py-2 rounded-lg mb-4" data-testid="mp-login-error">{error}</div>}
          <div className="mb-4">
            <label className="text-slate-400 text-xs font-medium mb-1.5 block">Email</label>
            <input
              type="email" value={email} onChange={e => setEmail(e.target.value)}
              className="w-full bg-[#0f1520] border border-white/10 rounded-lg px-3 py-2.5 text-white text-sm focus:outline-none focus:border-[#2D5A5A] transition-colors"
              placeholder="votre@email.pf" required data-testid="mp-login-email"
            />
          </div>
          <div className="mb-5">
            <label className="text-slate-400 text-xs font-medium mb-1.5 block">Mot de passe</label>
            <input
              type="password" value={password} onChange={e => setPassword(e.target.value)}
              className="w-full bg-[#0f1520] border border-white/10 rounded-lg px-3 py-2.5 text-white text-sm focus:outline-none focus:border-[#2D5A5A] transition-colors"
              placeholder="Mot de passe" required data-testid="mp-login-password"
            />
          </div>
          <button
            type="submit" disabled={loading}
            className="w-full bg-[#2D5A5A] hover:bg-[#3a7272] text-white font-medium py-2.5 rounded-lg text-sm transition-colors disabled:opacity-50"
            data-testid="mp-login-submit"
          >
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>

        <div className="mt-6 bg-[#1a2332]/50 border border-white/5 rounded-xl p-4 text-center" data-testid="mp-login-no-account">
          <p className="text-slate-400 text-sm mb-2">Vous n'avez pas encore de compte ?</p>
          <p className="text-slate-500 text-xs leading-relaxed mb-3">
            L'accès à Moana Paye est réservé aux clients du Groupe AERH Polynésie.
            Contactez-nous pour souscrire à l'une de nos formules.
          </p>
          <a href="/moana-paye#contact-moana" className="inline-flex items-center gap-1.5 text-[#E8A020] hover:text-[#d4911a] text-sm font-medium transition-colors" data-testid="mp-login-contact-link">
            Nous contacter pour souscrire
          </a>
        </div>

        <p className="text-center text-slate-600 text-xs mt-6">Groupe AERH Polynésie</p>
      </div>
    </div>
  );
}
